import { jwtDecode, JwtPayload } from "jwt-decode";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";

import { AuthStore } from "../../store/useAuthStore";

export interface ICustomPayload extends JwtPayload {
  UserInfo: {
    id: string;
    firstname: string;
    lastname: string;
    email: string;
    role: string;
    ownFarm: string;
    farm: string;
    farmName: string;
  };
}

interface RequireAuthProps {
  allowedRoles: string[];
}

const RequireAuth = ({ allowedRoles }: RequireAuthProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userInfo } = AuthStore();
  let content;

  if (userInfo.token) {
    const decoded = jwtDecode(userInfo.token);
    const { UserInfo } = decoded as ICustomPayload;

    if (UserInfo.role) {
      content = allowedRoles.includes(UserInfo.role) ? (
        <Outlet />
      ) : (
        <Navigate replace state={{ from: location }} to="/login" />
      );
    } else if (!userInfo) {
      navigate("/login");
    }
  }

  return content;
};

export default RequireAuth;
